import { useBootstrapContext } from "./bootstrapContext";

export function useBootstrap() {
  return useBootstrapContext();
}
